import Vue from 'vue'
import '../static/css/reset.css'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import App from './App'
import router from './router'
import store from './store/index.js'
import './api/base.js'
import OSS from 'ali-oss'
import md5 from 'md5'
Vue.config.productionTip = false
Vue.use(ElementUI)
window.OSS = OSS
window.md5 = md5

new Vue({
	el: '#app',
	router,
	store,
	template: '<App/>',
	components: { App },
	created() {
		this.$root.loginUser = this.LS.getJSON('user_info');
	},
	methods: {
		async multipartUpload(file, fname, bucket) {
      // console.log('文件', file, fname);
			fname = "cega/" + fname;
			let nowDate = new Date();
			this.client = new OSS({
				endpoint: this.$root.aliyun.bucketEndpoint,
				accessKeyId: this.$root.aliyun.accessKeyId,
				accessKeySecret: this.$root.aliyun.accessKeySecret,
				stsToken: this.$root.aliyun.securityToken,
				bucket: bucket
			});
			try {
        let abortCheckpoint;
        let result = await this.client.multipartUpload(fname, file,{
          progress: (p, cpt, res) => {
            // 为中断点赋值。
            abortCheckpoint = cpt;
            // console.log(abortCheckpoint);
            // 获取上传进度。
            // console.log(p * 100);
          },
        });
        // console.log("result", result);
				// let head = await this.client.head(fname);
        // console.log("head", head);
        let url = result.res.requestUrls[0];
        const queryIndex = url.indexOf('?');
        if (queryIndex !== -1) {
          url = url.substring(0, queryIndex);
        }
        return url;
			} catch (e) {
				// 捕获超时异常
				if (e.code === 'ConnectionTimeoutError') {
					// console.log("Woops,超时啦!");
				}
				// console.log(e);
				return "";
			}
		},
		async bufferUpload(fname,buffer, bucket) {
			//console.log(bucket)
			fname = "cega/" + fname;
			let nowDate = new Date();
			this.client = new OSS({
				endpoint: this.$root.aliyun.bucketEndpoint,
				accessKeyId: this.$root.aliyun.accessKeyId,
				accessKeySecret: this.$root.aliyun.accessKeySecret,
				stsToken: this.$root.aliyun.securityToken,
				bucket: bucket
			});
			try {
				const bufferStr = new OSS.Buffer(buffer);
				await this.client.put(fname, bufferStr).then(function(result){
					return result
				})
				// let result = await this.client.multipartUpload(fname, file, {
				// 	progress: async function (p) {
				// 		//console.log('Progress: ' + p);
				// 	},
				// 	meta: {
				// 		year: nowDate.getYear()
				// 	},
				// 	mime: file.type
				// });
				// let head = await this.client.head(fname);
				// return head.res.requestUrls[0];
			} catch (e) {
				// 捕获超时异常
				if (e.code === 'ConnectionTimeoutError') {
					//console.log("Woops,超时啦!");
				}
				console.log(e);
				return "";
			}
		},
		getalicofig(_async = false) {
      console.log("getalicofig");
			let rs = this.LS.getJSON('aliconfig');
			if (rs == null || ((new Date()).getTime()) - rs.nowTime > ((60 * 60) * 1000)) {
				let data = this.tokenFun({});
        console.log("this.$root.ajaxali", this.$root.ajaxali);
				$.ajax({
					url: this.$root.ajaxali + '/stsNoLogin/getWriteAccess',
					type: "POST",
					beforeSend: (xhr) => {
						// this.$root.setxhr(xhr);
						// xhr.setRequestHeader('G-CallId', data.callId);
						// xhr.setRequestHeader('G-ReqTime', data.reqTime);
						// xhr.setRequestHeader('G-SignValue', data['G-SignValue']);
					},
					async: _async
				}).done(({
					code,
					msg,
					data
				}) => {
					if (code == 200) {
            console.log("OSSdat", data);
						rs = data[0];
						rs.nowTime = (new Date()).getTime();
						this.LS.setJSON('aliconfig', rs)
					}
				}).fail((res) => {
					//console.log(res)
				});
			}
			this.$root.aliyun = rs;
			return this.$root.aliyun;
		},
		setxhr(xhr, fun = null) {
			if (this.$root.loginUser != null) {
				xhr.setRequestHeader('Authorization', 'Bearer ' + this.$root.loginUser.token)
			}
			xhr.setRequestHeader('Accept-Language', 'en');
			xhr.setRequestHeader('Device-Type', '3')
			xhr.setRequestHeader('Device-Platform', 'web')
		},
	},
	data() {
		return {
			uppath: "cega/",
			ajaxali: '/service-oss',
			aliyun: null,
			callId: "CEGA",
			callSecret: "0yoygjrl7b2Wj6UjnBzw0eMVdtfQhq",
			client: null,
			loginUser: null,
			skey: "",
			project_image: () => {
				return new Object({
					file_id: -1,
					file_type: '',
					file_name: '',
					file_oss_name: '',
					file_size: '',
					file_width: '',
					file_height: ''
				});
			},
		}
	}
})



// WEBPACK FOOTER //
// ./src/main.js